module.exports = __webpack_public_path__ + "static/img/tira_azul.4fcdb2d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/tira_azul.jpg
// module id = yjEK
// module chunks = 47